import {X} from "react-feather";
import React from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import TextInput from "../Formik/TextInput";
import {PLATFORMS} from "../../services/constants/EnvironmentPlatforms";

export const ModalAddEditEnvironment = ({
    item = null,
    onHandleToggle,
    handleAction,
    title,
    message,
    errorMessage
}) => {
    const formik = useFormik({
        initialValues: {
            key: item?.key || "",
            value: item?.value || "",
            is_default: item?.is_default ?? false,
            platform: item?.platform || PLATFORMS[0]
        },
        validationSchema: Yup.object({
            key: Yup.string().trim().max(64, "Key cannot exceed 64 characters.").required("Key is required."),
            value: Yup.string().trim().max(1000, "Value cannot exceed 1000 characters.").required("Value is required."),
            platform: Yup.string().oneOf(PLATFORMS).required("Platform is required."),
            is_default: Yup.boolean()
        }),
        onSubmit: (values) => {
            handleAction({
                id: item?.id,
                payload: {
                    key: values.key.trim(),
                    value: values.value.trim(),
                    is_default: values.is_default,
                    platform: values.platform
                }
            });
        }
    });

    return (
        <div>
            <div className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    {title}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>
            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div className="sl-text-md sl-font-normal sl-text-gray-700">
                        {message}
                    </div>

                    <div className={'sl-mt-4 sl-flex sl-flex-col sl-gap-3'}>
                        <TextInput formik={formik} label={'Key'} name={'key'}/>
                        <TextInput formik={formik} label={'Value'} name={'value'}/>

                        <div className="sl-width-100 sl-text-left sl-flex sl-flex-col">
                            <span className="sl-font sl-font-medium sl-text-sm sl-text-gray-700">Platform</span>
                            <div className="sl-mt-2 sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex sl-relative">
                                <select
                                    name="platform"
                                    value={formik.values.platform}
                                    onChange={(e) => formik.setFieldValue('platform', e.target.value)}
                                    className="sl-input sl-border-none sl-rounded-lg sl-font sl-text-md sl-font-normal sl-m-0 sl-h-11 sl-w-fill-available sl-pl-2 sl-pr-8"
                                >
                                    {PLATFORMS.map((p) => (
                                        <option key={p} value={p}>{p}</option>
                                    ))}
                                </select>
                            </div>
                            {formik.touched.platform && formik.errors.platform && (
                                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm">{formik.errors.platform}</span>
                            )}
                        </div>

                        <label className="sl-flex sl-items-center sl-gap-2 sl-cursor-pointer sl-mt-2">
                            <input
                                type="checkbox"
                                name="is_default"
                                checked={formik.values.is_default}
                                onChange={(e) => formik.setFieldValue('is_default', e.target.checked)}
                            />
                            <span className="sl-font sl-text-sm sl-text-gray-700">Is default</span>
                        </label>
                    </div>

                    <div className="sl-text-error-500 sl-mt-4 sl-font sl-text-sm">
                        {errorMessage}
                    </div>
                </div>
            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle} className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg">
                        Cancel
                    </button>
                    <button onClick={formik.submitForm} className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalAddEditEnvironment;
